import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import {  getQuoteListApi,createTransactionApi } from "helpers/backend_helper";
import toastr from "toastr";
import { TocTwoTone } from "@mui/icons-material";
import {errorMsg, successMsg} from "helpers/toastr";

function* getQuoteListSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(getQuoteListApi, data);
    callback && callback(response)

    if (response.status == "failure") {
      return yield put(ACT.getQuoteListFail(response.message));
    }
    yield put(ACT.getQuoteListSuccess(response));
  } catch (error) {
    errorMsg(error?.response?.data?.message);

    yield put(ACT.getQuoteListFail(error));
  }
}

function* createTransactionSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(createTransactionApi, data);
    callback && callback(response)

    if (response.status == "failure") {
      return yield put(ACT.createTransactionFail(response.message));
    }
    yield put(ACT.createTransactionSuccess(response));
  } catch (error) {
    yield put(ACT.createTransactionFail(error));
  }
}


function* unirampSaga() {
  yield takeEvery(CONST.GET_QUOTE_LIST, getQuoteListSaga);
  yield takeEvery(CONST.CREATE_TRANSACTION, createTransactionSaga);

}

export default unirampSaga;
